import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { buttonStyle } from "./Button"
import cx from "classnames"

const Link = ({ children, to, className = "", button = false, styled = false, blank = false, ...props }) => {
  const inPage = to.charAt(8) === "#"
  const external = to.charAt(0) !== "/"
  const target = blank ? "_blank" : "_self"

  if (!external) {
    return children && to && <GatsbyLink
      to={to}
      target={target}
      {...(blank ? { rel: 'noopener' } : {})}
      onClick={props.onClick ? () => props.onClick() : undefined}
      className={cx(className, { [buttonStyle(props)]: button, "text-link-unstyled": !styled })}
    >
      {children}
    </GatsbyLink>
  }

  return children && to && <a
    target={target}
    href={inPage ? to.substring(8) : to}
    className={cx(className, { [buttonStyle(props)]: button, "text-link-unstyled": !styled })}
    rel="noopener"
  >
    {children}
  </a>
}

export const ArrowLink = ({ children, negative = false, className = "", ...props }) => {
  return <Link
    className={cx(className, "flex items-center font-bold whitespace-nowrap	transition-all duration-100",
      { "text-blue-10 stroke-blue-10 hover:stroke-blue-30 hover:text-blue-30": !negative },
      { "text-white stroke-white hover:stroke-blue-50 hover:text-blue-50": negative }
    )}
    {...props}
  >
    {children} < svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <path d="M6 13L10 9L6 5" strokeWidth="1.33333" strokeLinejoin="round" />
    </svg >

  </Link >
}

export default Link